module.exports = __webpack_public_path__ + "img/elCalafate.84082594.jpg";